'use strict';

const UINavigationToggle = require('./ui-navigation-toggle');
const LoginValidation = require('./login-validation');
const SignUpValidation = require('./signup-validation');
const NonEssentialElementsLoader = require('../../../login-async/frontend/non-essential-elements-loader');
const Social = require('./social');
const Controls = require('./controls');

module.exports = () => {
  NonEssentialElementsLoader.init();
  UINavigationToggle.init();
  LoginValidation.init();
  SignUpValidation.init();
  Social.init();
  Controls.init();
};
